import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';
import { env } from '@/config/env';

const baseUrl = import.meta.env.BASE_URL.replace(/\/$/, '');
const redirectUri = `${window.location.origin}${baseUrl}/`;

/**
 * Dedicated blank page used as redirectUri for silent/iframe token acquisition.
 * Keeps MSAL's hidden iframe fast (no app bundle) and prevents monitor_window_timeout.
 */
export const silentRedirectUri = `${window.location.origin}${baseUrl}/auth/redirect.html`;

export const msalConfig: Configuration = {
  auth: {
    clientId: env.VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${env.VITE_MSAL_TENANT_ID}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
        else if (level === LogLevel.Info) console.info(message);
      },
      logLevel: LogLevel.Info,
    },
  },
};

const apiScopes = [`${env.VITE_MSAL_CLIENT_ID}/.default`];

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', ...apiScopes],
};

export const apiTokenRequest = {
  scopes: apiScopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);
